import React, { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import { useQuery } from 'react-query'
import { axiosPostCall, axiosGetCall } from '../../../services/apisCall';
import { renderErrorMessage, renderSuccessMessage } from '../../../lib/toastMessage';

//mui
import { Box, Button, TableCell, TableContainer, Table, TableHead, TableRow, Popover, Paper, TableBody, styled, Tooltip, Chip, IconButton, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

// config
import { USER_KYC_LIST_REFETCH_TIME } from '../../../config/commonConfig';

//logger
import Logger from '../../../lib/Logger';
import { checkButtonAccess } from 'src/utils/common';
import moment from 'moment';
import Iconify from 'src/components/iconify';
import { jwtDecode } from 'jwt-decode';
import CustomTabPanel from 'src/sections/voice/announcement-ivr/customTabPanel';
import { PaginationTable } from '../template/paaginationTable';
import { ConfirmDialog } from 'src/components/custom-dialog';
import SenderIDFilters from './filter';
const logger = new Logger("kycListTable");

const HeadingSection = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "12px",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "10px",
        flexWrap: "wrap",
    },
}));

export const SenderIDTable = () => {

    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [rows, setRows] = useState([])
    const [count, setCount] = useState(0)
    const [search, setSearch] = useState("")
    const [load, setLoad] = useState(false)
    const [networkError, setNetworkError] = useState(false)
    const [loading, setLoading] = useState(true)
    const [selectedStatus, setSelectedStatus] = useState("P")
    const [confirmModal, setConfirmModal] = useState(false)

    const [filterLabels, setFilterLabels] = useState([]);
    const [isFilterApplied, setIsFilterApplied] = useState(false);
    const { email } = jwtDecode(localStorage.getItem("token"));

    const [selectedRow, setSelectedRow] = useState(null);
    const [rejectionReason, setRejectionReason] = useState("");
    const [filterData, setFilterData] = useState({
        userId: "",
        senderId: "",
        from: null,
        to: null,
    });

    const ttsTemplateColumns = [
       { id: 'user_id', label: 'User ID', minWidth: 110, align: 'center' },
        { id: 'record_id', label: 'Record Id', minWidth: 110, align: 'center' },
        { id: 'country', label: 'Country', minWidth: 110, align: 'center' },
        { id: 'sender_id', label: 'Sender Id', minWidth: 110, align: 'center' },
        { id: 'create_date', label: 'Date & Time', minWidth: 110, align: 'center' },
        { id: 'route', label: 'Route', minWidth: 110, align: 'center' },
        { id: 'actions', label: 'Action', minWidth: 110, align: 'center' },
    ];

    if (selectedStatus === "R") {
        ttsTemplateColumns.splice(5, 0, { id: 'rejectionReason', label: 'Rejection Reason', minWidth: 150, align: 'center' });
        ttsTemplateColumns.splice(6, 0, { id: 'action_by', label: 'Rejected BY', minWidth: 150, align: 'center' });
    }

    if (selectedStatus === "A") {
        ttsTemplateColumns.splice(5, 0, { id: 'action_by', label: 'Approved BY', minWidth: 150, align: 'center' });
    }

    const resetFilters = () => {
        setFilterLabels([]);
        setSearch("");
        setFilterData({
            userId: "",
            templateId: "",
            from: null,
            to: null,
        });
        setIsFilterApplied(false);
        setLoad(true);
    };

    const apply = (data) => {
        // setRows([]);
        setSearch("");
        setIsFilterApplied(true);

        const label = [];

        Object.keys(data).forEach((element) => {
            data[element] &&
                label.push({ key: filterLabelMap[element], value: data[element] });

        });
        setFilterLabels(label);

        const newData = JSON.parse(JSON.stringify(data));
        setFilterData(newData);
        // setPage(0);
        setLoad(true);
    };

    const generateLabelChipToolTip = (item) => {
        if (["From", "To"].includes(item?.key))
            return moment(item?.value).format("D MMM, YYYY");
        else return item?.value;
    };

    const filterLabelMap = {
        status: "Status",
        userId: "UserId",
        templateId: "TemplateId",
        from: "From",
        to: "To"
    };

    const reset = () => {
        resetFilters();
    };

    const findForSearchQuery = (search) => {
        setSearch(search);
        if (search?.trim()) {
            setPage(0);
            setLoad(true);
            if (!filterLabels.includes("search"))
                setFilterLabels([{ key: "search", value: search }]);
            setIsFilterApplied(false);
            return;
        }
        const updatedLabels = filterLabels.filter((item) => item?.key !== "search");
        setFilterLabels([...updatedLabels]);
        // setRows([]);
        setIsFilterApplied(false);
        // setPage(0);
        setLoad(true);
    };

    const handleChange = (value) => setSearch(value)

    const getSenderList = async () => {
        const skip = rowsPerPage * page;
        try {
            let params = { skip, limit: rowsPerPage }
            if (search) params.search = search
            if (selectedStatus) params.status = selectedStatus

            params = { ...params, ...filterData }

            setNetworkError(false)

            const data = await axiosGetCall("getSmsSenderList", params)
            setLoading(false);
            return data

        } catch (error) {
            logger.error("senderListTable.jsx ,getSenderList ,getSenderList", error);
            setNetworkError(true)
            setRows([])
            setCount(0)
            renderErrorMessage(error?.message)
        }
        setLoading(false)
    }

    const { data, refetch } = useQuery({ queryKey: ['getSenderList', selectedStatus, page, rowsPerPage], queryFn: getSenderList, refetchOnWindowFocus: false, retry: false, refetchInterval: USER_KYC_LIST_REFETCH_TIME })
    useEffect(() => {

        setRows(data?.senderIdList || [])
        setCount(data?.totalSenderIdListCount || 0)

    }, [data])

    useEffect(() => {
        if (load) {
            setLoading(true)
            refetch()
        }
        setLoad(false)
    }, [load])


    const tableFilter = (
        <HeadingSection>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "10px",
                    alignItems: "center",
                }}
            >
                {/* <HeadingTypography>Customers</HeadingTypography> */}

                {!!filterLabels.length && (
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "6px",
                            alignItems: "center",
                            flexWrap: "wrap",
                        }}
                    >
                        {filterLabels.map((item) => (
                            <Tooltip title={generateLabelChipToolTip(item)}>
                                <Chip label={item?.key} variant="outlined" size="small" />
                            </Tooltip>
                        ))}

                        <Button
                            variant="outlined"
                            size="small"
                            color="warning"
                            onClick={() => resetFilters()}
                        >
                            Clear Filter
                        </Button>
                    </Box>
                )}
            </Box>

            <SenderIDFilters
                findForSearchQuery={findForSearchQuery}
                // getPlansList={refetch}
                apply={apply}
                reset={reset}
                search={search}
                isFilterApplied={isFilterApplied}
                filterData={filterData}
                setFilterData={setFilterData}
            />
        </HeadingSection >
    )

    const rejectStatus = (row) => {
        setSelectedRow(row)
        setConfirmModal(true);
    }

    const senderStatus = async (row, status, type, rejectionReason) => {

        try {
            const { message } = await axiosGetCall("ChangeRecordStatus", { type: 'senderId', recordId: row?.record_id, action: status, adminEmail: email, rejectionReason })

            renderSuccessMessage(message);
            setConfirmModal(false);
            refetch();

        } catch (error) {
            console.log(error);
            logger.error("senderListTable.jsx ,senderStatus ,senderStatus", error);
            renderErrorMessage(error?.message)
        }
    }

    const content = (
         <Box>
            Are you sure you want to <span style={{ fontWeight: 'bold' }}>Reject</span> this sender ID.
            <TextField
            required
            id="outlined-required"
            label="Reason"
            multiline
            maxRows={4}
            fullWidth
            value={rejectionReason}
            onChange={(e) => setRejectionReason(e.target.value)}
            sx={{ marginTop: "10px" }}
            />
        </Box>
    )

    const ActionJsx = ({ id, align, value, row }) => {
        return (
            <TableCell
                key={id}
                align={align}
                sx={{
                    color: 'grey.400',
                    borderBottom: '0.5px dashed',
                    borderColor: 'grey.300',
                    size: 'small'
                }}>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "5px"
                    }}
                >

                    {checkButtonAccess("approveAnnouncementIvr", "w") && <>
                        {row?.status !== 1 && 
                        <IconButton 
                        onClick={() => senderStatus(row, "A", "status")}
                        ><Iconify icon="mdi:tick" sx={{ color: "green" }} /></IconButton>}
                        {row?.status !== 2 && <IconButton 
                        onClick={() => rejectStatus(row, "R")}
                        ><Iconify icon="mdi:close" sx={{ color: "red" }} /></IconButton>}
                    </>}
                </Box>
            </TableCell>
        )
    }

    const contentStyle = { height: '20px', width: '20px', marginRight: '5px' }
    
    const templateJsx = ({ id, align, value, row }) => {
  const displayValue = value?.toString().slice(0, 50) || "--";
  const isTruncated = value && value.length > 50;

  return (
    <TableCell
      key={id}
      align={align}
      sx={{
        color: 'grey.700',
        borderBottom: '0.5px dashed',
        borderColor: 'grey.300',
        maxWidth: 200,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      {isTruncated ? (
        <Tooltip title={value}>
          <span>{displayValue}...</span>
        </Tooltip>
      ) : (
        value || "--"
      )}
    </TableCell>
  );
};



    const RouteJsx = ({ id, align, value, row }) => {
        const color = {
            promotional: "warning.dark",
            other: "warning.dark",
        }

        const label = {
            promotional: "Promotional",
            other: "Other",
        }

        const [anchorEl, setAnchorEl] = React.useState(null);

        const handleClick = (event) => {
            setAnchorEl(event.currentTarget);
        };

        const handleClose = () => {
            console.log("close")
            setAnchorEl(null);
            value !== route && updateRoute();
        };

        const open = Boolean(anchorEl);
        const popoverId = open ? 'simple-popover' : undefined;

        const [route, setRoute] = useState(value);

        const handleChange = (event) => {
            setRoute(event.target.value);
        };

        const updateRoute = () => {
            senderStatus(row, route, "route")
        }


        return <TableCell
            key={id}
            align={align}
            sx={{
                color: 'grey.700',
                borderBottom: '0.5px dashed',
                borderColor: 'grey.300',
            }}>
            <>
                {value ?
                        <Chip label={label[value]}
                            sx={{
                                backgroundColor: 'transparent',
                                color: color[value],
                                '&:hover': {
                                    backgroundColor: 'transparent', color: color[value]
                                },
                            }}
                        />
                    : "--"}
            </>
        </TableCell>
    }



    const TtsContentJsx = ({ id, align, value, row }) => {
        const [anchorEltts, setAnchorEltts] = React.useState(null);

        const handleClicktts = (event) => {
            setAnchorEltts(event.currentTarget);
        };

        const handleClosetts = () => {
            setAnchorEltts(null);
        };

        const opentts = Boolean(anchorEltts);
        const Id = opentts ? 'simple-popover' : undefined;

        return <TableCell
            key={id}
            align={align}
            sx={{
                color: 'grey.700',
                borderBottom: '0.5px dashed',
                borderColor: 'grey.300',
            }}>
            {Object.keys(value || {}).length > 0 ? <div>
                <Button aria-describedby={Id} variant="contained" onClick={handleClicktts} color='success'>
                    Content
                </Button>
                <Popover
                    id={Id}
                    open={opentts}
                    anchorEl={anchorEltts}
                    onClose={handleClosetts}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                >
                    {/* <Typography sx={{ p: 2 }}>The content of the Popover.</Typography> */}
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 200 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>

                                    <TableCell align="right">Node</TableCell>
                                    <TableCell align="right">Content</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Object.keys(value).map((key) => (
                                    <TableRow
                                        key={key}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            {key}
                                        </TableCell>
                                        <TableCell align="right">{value[key]}</TableCell>

                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Popover>
            </div> : "--"}
        </TableCell>
    }

    return (
        <>
            {/* <ToastContainer /> */}
             <ConfirmDialog
                open={confirmModal}
                onClose={() => setConfirmModal(false)}
                title="Update Template Status"
                content={ content }
                action={
                    <Button
                    color="secondary"
                    variant="contained"
                    sx={{
                        color: '#fff',
                        height: '30px',
                        backgroundColor: 'primary.main',
                        '&:hover': {
                            backgroundColor: 'primary.main',
                        },
                        boxShadow: "none",
                        marginRight: '10px'
                    }}
                        onClick={() => senderStatus(selectedRow, "R", "status", rejectionReason)}
                        >Confirm
                </Button>
                }
                />
            <CustomTabPanel setSelectedStatus={setSelectedStatus} setLoading={setLoading} setPage={setPage} />
            <PaginationTable
                page={page}
                tableFilter={tableFilter}
                ActionJsx={ActionJsx}
                // ActionModals={ActionModals}
                setLoad={setLoad}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                count={count}
                error={networkError}
                loading={loading}
                setLoading={setLoading}
                rows={rows}
                columns={ttsTemplateColumns}
                handleChange={handleChange}
                search={search}
                calculatedHeight={377}
                TtsContentJsx={TtsContentJsx}
                RouteJsx={RouteJsx}
                Template={templateJsx}
            />
        </>
    )
}